<template>
  <div class="result_cur_condition" v-if="$store.state.app.view_pattern === 'pc'">
    <div class="result_cur_condition_left" v-if="isSystem">
      <h1 class="result_title1 condition-cate-title" v-text="(typeName ? typeName :getLang($t('widgets_basic_product_display_components_cur_condition_2776')))"></h1>     
    </div>
    <div class="result_cur_condition_left" v-show="false">
      <h1 class="result_title"> {{ getLang($t('widgets_basic_product_display_components_cur_condition_2777')) }}：</h1>
      <div class="result_current_condition" v-if="typeIsShow">
        <span class="result_cur_value" v-text="typeName"></span>
        <i class="result_cur_icon el-icon-close" @click="delType"></i>
      </div>
    </div>
    <div class="result_cur_condition_right" v-if="pc_infor.search_is_open === 'true'">
      <el-input v-model="keyword" :placeholder="getLang($t('widgets_basic_product_display_components_cur_condition_2778'))" class="result_rearch" autocomplete="off"></el-input>
      <i class="iconfont icon-fangdajing result_rearch_icon" @click="searchPro"></i>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: "cur_condition",
  data() {
    return {
      keyword: '',
      typeIsShow: false,
      isSystem: this.module.data.isSystem === 'true' ? true : false
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    typeName: {
      type: String,
      default: ''
    }
  },
  watch: {
  },
  methods: {
    delType() {
      this.typeIsShow = false
      this.keyword = ''
      this.$emit('delType',this.keyword)
    },
    searchPro() {
      this.$emit('searchPro',this.keyword)
    },
    getProductType() {
      this.templet.get_product(this);
    },
  },
  computed: {
    pc_infor() {
      return this.module.data.pc_widgets_infor
    },
  },
  components: {},
  created() {},
  mounted() {
    this.typeIsShow = this.typeName !== '' ? true : false
  }
};
</script>

<style scoped lang="scss">
.result_cur_condition {
    position: relative;
    height: 74px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
    .result_cur_condition_left {
        float: left;
        height: 32px;
        line-height: 32px;
        padding: 20px 0;
        margin-left: 10px;
        .result_title1 {
            font-weight: bold;
            display: inline-block;
        }
        .result_title {
            font-size: 13px;
            display: inline-block;
            &:after {
                content: "";
                display: inline-block;
                width: 5px;
            }
        }
        .result_current_condition {
            display: inline-block;
            border: 1px solid #ebebeb;
            text-decoration: none;
            height: 32px;
            width: auto;
            min-width: 65px;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            padding-left: 11px;
            font-size: 0;
            margin-right: 10px;
            .result_cur_value {
                font-size: 14px;
                color: #333;
                display: inline-block;
                line-height: 30px;
            }
            .result_cur_icon {
              font-size: 14px;
              color: #c0c4cc;
              font-weight: lighter;
              text-decoration: none;
              display: inline-block;
              margin: 0 8px 0 12px;
              cursor: pointer;
            }
        }
    }
    .result_cur_condition_right {
        float: right;
        padding: 18px 0;
        .result_rearch {
            position: relative;
            box-sizing: border-box;
            width: 250px;
        }
        .result_rearch_icon {
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            cursor: pointer;
            font-size: 25px;
            height: 12px;
            padding-top: 20px;
            padding-right: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_product_display/components/cur_condition.vue